import { BLACK_HOLE } from 'utils/constants';

const SpotLight = ({ unlocked, showAll }) => (
  <div className='weapon'>
    {!showAll && <div className='title'>You should pick Spotlight</div>}
    {showAll && <div className='title'>Spotlight</div>}
    {(showAll || !unlocked[BLACK_HOLE]) && (
      <div className='info'>
        Keep looking for Black Hole before building this.
      </div>
    )}
  </div>
);

export default SpotLight;
